import { SERVICE_NAMESPACE } from 'common';

export const URL = (apiUrl = '') => `${apiUrl}/checks/withdrawals/printedMailingAddressPreview`;

export const NAMESPACE = `${SERVICE_NAMESPACE}/ADDRESS`;

export const LOADING = `${NAMESPACE}/LOADING`;
export const SUCCESS = `${NAMESPACE}/SUCCESS`;
export const NOT_ASKED = `${NAMESPACE}/NOT_ASKED`;
export const FAILURE = `${NAMESPACE}/FAILURE`;
export const ADDRESS_REQUEST = `${NAMESPACE}/REQUEST`;



// WEBPACK FOOTER //
// ./src/services/addressPreview/constants.js